// extracted by mini-css-extract-plugin
module.exports = {"popover__overlay":"popover__overlay__2FLro","popover__overlay--visible":"popover__overlay--visible__220hl","popover__container":"popover__container__1sbvl"};